// Table — minimal styled <table>. For declarative grids with
// columns + rows, use DataGrid instead.

export default function Table({ children, style: styleOverride }) {
  return (
    <table
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontFamily: 'var(--font-body)',
        fontSize: 12,
        color: 'var(--olv-text-primary)',
        ...styleOverride,
      }}
    >
      {children}
    </table>
  )
}

export function THead({ children }) {
  return <thead>{children}</thead>
}

export function TBody({ children }) {
  return <tbody>{children}</tbody>
}

export function TR({ children, onClick, active = false, tabStop = true }) {
  // Clickable rows must be keyboard-operable: focusable, with
  // Enter/Space triggering the same handler as the click. Rows use a
  // roving pattern — the grid contributes ONE tab stop (tabStop only
  // on the first row); ArrowUp/ArrowDown move between rows, and Tab
  // leaves the grid instead of walking every row.
  const interactive = typeof onClick === 'function'
  return (
    <tr
      onClick={onClick}
      tabIndex={interactive ? (tabStop ? 0 : -1) : undefined}
      onKeyDown={
        interactive
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onClick(e)
              } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault()
                const sibling =
                  e.key === 'ArrowDown'
                    ? e.currentTarget.nextElementSibling
                    : e.currentTarget.previousElementSibling
                if (sibling && typeof sibling.focus === 'function') sibling.focus()
              }
            }
          : undefined
      }
      style={{
        borderBottom: '1px solid var(--olv-panel-border)',
        background: active ? 'rgba(124,92,252,0.06)' : 'transparent',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'background 200ms var(--ease-standard)',
      }}
    >
      {children}
    </tr>
  )
}

export function TH({ children, align = 'left', width }) {
  return (
    <th
      scope="col"
      style={{
        textAlign: align,
        width,
        padding: '10px 12px',
        fontSize: 9,
        color: 'var(--olv-text-tertiary)',
        fontFamily: 'var(--font-mono)',
        letterSpacing: '0.10em',
        textTransform: 'uppercase',
        fontWeight: 500,
        borderBottom: '1px solid var(--olv-panel-border)',
      }}
    >
      {children}
    </th>
  )
}

export function TD({ children, align = 'left', mono = false }) {
  return (
    <td
      style={{
        textAlign: align,
        padding: '10px 12px',
        fontFamily: mono ? 'var(--font-mono)' : 'var(--font-body)',
        fontSize: 12,
        color: 'var(--olv-text-secondary)',
      }}
    >
      {children}
    </td>
  )
}
